import { useNavigate } from '@tanstack/react-router';
import { Button } from '@workspace/web-ui/components/button';
import emptyAppointment from "~/assets/images/dashboard/empty-appointment.svg";

type EmptyAppointmentProps = {
  timeline: string;
};

const EmptyAppointment = ({ timeline }: EmptyAppointmentProps) => {
  const navigate = useNavigate()
  return (
    <div className="flex min-h-screen w-full mx-auto overflow-hidden">
      <div className="bg-white p-8 h-2/4 lg:h-3/4 mx-auto overflow-hidden rounded-lg shadow-md text-center flex flex-col justify-center items-center">
        {/* Icon Section */}
        <div className="flex justify-center mb-4">
          <div className="">
            <img src={emptyAppointment} alt='empty appointment image' sizes="25" />
          </div>
        </div>

        {/* Text Section */}
        <h2 className="text-lg font-medium mb-2">Nothing yet</h2>
        <p className="text-[#202020CC] text-base font-medium mb-6 lg:w-1/2 md:w-4/5">
          You currently do not have any {timeline} appointments. Once you book an appointment, it will appear here for easy access.
        </p>

        {/* Button Section */}
        <Button onClick={() => navigate({ to: "/dashboard/weight-loss/appointments/booking" })} className="border-[#DCDCDE] bg-[#FFFFFF] text-[#202020CC] text-sm font-medium py-2 px-4 rounded hover:bg-gray-50">
          Book an appointment
        </Button>
      </div>
    </div>
  );
};

export default EmptyAppointment;
